import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	selectField: {
		id: 'polaris-ideas.idea-view.connections.content.header.field-select.select-field',
		defaultMessage: 'Select highlighted field',
		description: 'Button label to select a field',
	},
});
